import { createSelector } from 'reselect';

export const selectStateError = () => state => state.error;

export const selectCodeError = () =>
  createSelector(
    selectStateError(),
    error => error.code
  );

export const selectMessageError = () =>
  createSelector(
    selectStateError(),
    error => error.message
  );
